<style scoped>
.avatar-card {
  background-color: white;
  border-radius: 8px;
}
.ivu-checkbox-group-item,
.ivu-radio-wrapper {
  display: block;
}

.form-item-label {
  line-height: normal !important;
  padding-bottom: 10px;
}

.ivu-form-item .ivu-form-item {
  margin-bottom: 22px;
}

.ivu-form-item .ivu-form-item:last-child {
  margin-bottom: 0;
}
.required {
  color: red;
  font-size: 15px;
}
</style>

<style>
.onboarding-form.is-last-page .wizard__back.pull-left {
  display: none;
}

.text-zipcode > input {
  height: 40px;
  font-size: 17px;
}
.check-interest {
  font-size: 2.5vh !important;
}

.onboarding-page-template .ivu-form-item-label {
  font-weight: bold;
  font-size: 18px;
}

.onboarding-page-template .unbold > .ivu-form-item-label {
  font-weight: normal;
}

.onboarding-page-template .wizard__arrow,
.wizard__steps {
  display: none !important;
}
.onboarding-page-template .wizard__body {
  margin-top: 10px !important;
  background: transparent !important;
  border-color: transparent !important;
}
.onboarding-page-template .wizard__body__actions {
  display: flex;
  justify-content: flex-end;
  background-color: transparent !important;
  border: none !important;
}
.onboarding-page-template .wizard__body__actions a {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  border-radius: 5px;
  line-height: 32px !important;
  font-weight: 300 !important;
}
.onboarding-page-template .wizard__body__step {
  /* height: 70vh;; */
}
.onboarding-page-template .wizard__body__step .ivu-form-item-label {
  font-size: 3vh;
  line-height: 1.5;
  font-weight: normal;
  width: 100%;
  display: block;
  text-align: center;
}
.onboarding-page-template .custom-checkbox-advocacies {
  display: inline-block;
  width: 100px;
  text-align: center;
  margin: 0 5px;
  padding: 3px;
  border: 1px solid #ddd;
  position: relative;
  border-radius: 3px;
}
.onboarding-page-template .custom-checkbox-advocacies .ivu-checkbox {
  display: none;
}
.onboarding-page-template .custom-checkbox-advocacies .ivu-avatar {
  margin: 0;
}
.onboarding-page-template
  .custom-checkbox-advocacies.ivu-checkbox-wrapper-checked {
  border: 1px solid var(--primary-color);
  border-radius: 3px;
}
.onboarding-page-template
  .custom-checkbox-advocacies.ivu-checkbox-wrapper
  .isSelected {
  display: none;
}
.onboarding-page-template
  .custom-checkbox-advocacies.ivu-checkbox-wrapper-checked
  .isSelected {
  display: initial;
  position: absolute;
  top: 5px;
  right: 5px;
}
.wizard__back.pull-left {
  padding: 0 !important;
  line-height: 40px !important;
  margin-right: 10px !important;
  height: 32px !important;
  width: 54.77px !important;
}
a.wizard__back.pull-left {
  /* width: 100px !important;
  float: right !important;
  margin-right: 10px !important; */
  background-color: transparent !important;
  padding: 2px 10px !important;
  height: fit-content !important;
  width: fit-content !important;
}
a.wizard__back.pull-left:after {
  line-height: 32px;
  color: #495060;
  content: "Go Back";
  font-weight: 300;
}
.wizard__back > span {
  display: none !important;
}
.wizard__next > span {
  /* line-height: 32px;
  margin-bottom: 3px; */
}
a.wizard__next.pull-right {
  float: right !important;
}
.wizard__next.pull-right {
  padding: 2px 10px !important;
  height: fit-content !important;
  width: fit-content !important;
}
a .wizard__next .pull-right .final-step {
  line-height: 32px !important;
}

.vgw-icon.vgw-next::after,
.vgw-icon.vgw-prev::after {
  display: none;
}

.btn-last-page {
  width: 150px;
  background-color: #2d8cf0 !important;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  -webkit-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  padding-right: 8px !important;
  padding-left: 8px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.btn-fb {
  width: 150px;
  background-color: #41579b !important;
  margin-bottom: 10px;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  text-align: center;
  cursor: pointer;
  -webkit-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  padding-right: 8px !important;
  padding-left: 8px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.last-page a:hover {
  color: white;
}

.last-page {
  width: auto;
  display: grid;
  position: absolute;
  left: 50%;
  margin-left: -75px;
  bottom: 10px;
}
.ivu-select-dropdown.ivu-auto-complete {
  max-height: 149px;
}
.age-modal .ivu-modal-footer {
  border-top: 1px solid #e9eaec !important;
}
.age-modal .ivu-modal-header {
  border-bottom: 0px !important;
}
.PH > .active {
  border-width: 2px !important;
  border-color: blue !important;
  background-color: white !important;
}
.avatar-icon {
  background-color: white !important;
  padding: 6px !important;
}
.i-icon {
  display: inline-block;
  font-family: "custom-font" !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  text-rendering: auto;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  vertical-align: middle;
}
.i-icon-accessory: {
}
.required-center {
  float: left;
  margin: 3px 4px 0px 0px;
}
.required-fields {
  font-size: 10px;
  margin-top: -15px;
  display: flex;
}
.avatars {
  display: flex;
  flex-direction: row;
  flex-flow: wrap;
  overflow-y: scroll;
  height: 40vh;
  padding: 10px;
}

.avatars > img {
  width: 80px !important;
  height: 80px !important;
  margin: 3px auto;
  border-radius: 100%;
  border: 5px solid #ddd;
}
</style>


<template>
  <app-layout class="onboarding-page-template">
    <Form
      class="onboarding-form"
      :class="{
          'is-last-page': isLastPage
        }"
      :model="form"
      ref="onboardingForm"
      :rules="rules"
      label-position="top"
    >
      <vue-good-wizard
        ref="wizard"
        final-step-label="Finish"
        :steps="steps"
        :onNext="nextClicked"
        :onBack="backClicked"
      >
        <div slot="pageConsent2Message">
          <div style="width: 100%;height: 60vh; overflow-y:auto">
            <span>
              Dear <b>Osteopathic Medical Student</b>: 
              <br>
              <br>
              You are invited to complete a series of brief surveys as part of aresearch project conducted by VCOM researchers: 
              Natalie M.Fadel, PsyD, Alexis M. Stoner, PhD, MPH, Lindsey M. Ridgeway, PhD, MEd, Harold Garner, PhD, and Ning Cheng, PhD; 
              and the Co-Founders and COOs of Resiliency Technologies: Tim Farrell and Robyn Hussa Farrell. 
              The research team was awarded grant funding to develop content for this app specific to the needs of VCOM students. 
              <br>
              <br>
              Participation in the study includes completion of a brief survey upon initial log in, a survey six months later and a last survey after one year of usage. 
              The survey takes approximately 10 minutes to complete, and asks about your current resiliency levels, connectedness to mental health and wellness services, 
              and thoughts on the VCOM mental health and wellness app. Those who consent to participate in the study will be entered into a drawing for a $25 Amazon gift card, 
              of which 3 total gift cards will be offered. This survey is voluntary. All students are free to decline participation and 
              this choice will not impact any academics or opportunities to use the app.
              <br>
              <br>
              By completing this survey, you affirm that you are at least 18 years old and are aware that your responses may be used for research purposes. 
              Your responses will remain confidential, as your data will be de-identified. 
              By submitting your responses,you give your consent for the research team to use your survey answers 
              and for the research team to use your usability data from your app usage in analysis for the study and publication of the results. 
              If you have any questions about this survey before or after you complete the survey, 
              please contact Natalie Fadel, <a href="mailto:nfadel@carolinas.vcom.edu">nfadel@carolinas.vcom.edu</a>. 
              If you have any concerns or questions about your rights as a future participant in research, please contact the Chairman of the VCOM Institutional Review Board, 
              Dr. Brolinson at <a href="mailto:pbrolins@vcom.vt.edu">pbrolins@vcom.vt.edu</a>.
            </span>         
          </div>
          <div
            style="display: flex; justify-content: center; width: 100%; margin: 20px 0"
          >
            <Button @click="next(false)" style="margin-right: 10px;">Disagree</Button>
            <Button @click="next(true)" type="primary">Agree</Button>
          </div> 
        </div>

        <div style="height:100%" slot="pageConsent2">
          <IframeComponent @onLoad='onIframeLoaded' style="width: 100%;height: 60vh" srcUrl='https://virginiatech.qualtrics.com/jfe/form/SV_6u3hqvCZQrX2Ytv'/>
          <div style="font-size:14px;color:red">
            Please be sure you have completed all survey questions above before selecting the Next button.
          </div>
          <div
            style="display: flex; justify-content: flex-end; width: 100%; margin: 20px 0"
          >
            <Button @click="surveyNext(false)" type="text" style="margin-right: 10px;">Go Back</Button>
            <Button :disabled="!showSurveyNext" @click="surveyNext(true)" type="primary">Next</Button>
          </div> 
        </div>

        <div slot="pageEmail">
          <div style="margin: 20px 0">
            <b>Please {{brandConsentForm.user_agree ? 'confirm' : 'input'}} your email address:</b>
          </div>
          <Input v-if="!consentLoading" @on-enter='preventEnter' v-model="brandConsentForm.email" @on-change="validateEmail"/>
        </div>

        <div slot="pageConsent">
          <div v-if="onboardConsent" style="display: flex; flex-direction: column;">
            <OnBoardingActivity
              style="height: 70vh; overflow-y: auto"
              @load="consentLoaded = false"
              @loaded="consentLoaded = true"
              :aid="onboardConsent"
            />
            <div
              v-if="consentLoaded"
              style="display: flex; flex-direction: row; justify-content: center; width: 100%; margin-top: 10px;"
            >
              <Button @click="accept(false)" style="margin-right: 10px;">Disagree</Button>
              <Button @click="accept(true)" type="primary">Agree</Button>
            </div>
          </div>
        </div>

        <div slot="pageWelcome">
          <div v-if="onboardVideo">
            <OnBoardingActivity :aid="onboardVideo" />
          </div>
          <p
            v-else
            style="text-align:center;font-size: 3vh;line-height: 1.5;margin-bottom:16px"
          >Are you ready to learn and engage. You are free to register completely anonymously, but you must agree to treat everyone you find here civilly.</p>
          <div class="end-comment" style="display: flex; justify-content: center;">
            <img src="@/assets/end-comment.png" width="80px" height="40px" style="margin-top:-5px" />
          </div>
        </div>

        <div slot="pageIntro">
          <div v-if="introContent">
            <OnBoardingActivity :aid="introContent" />
          </div>
        </div>

        <div slot="pageAvatar">
          <FormItem label>
            <!-- <Upload
                  :show-upload-list="false"
                  ref="uploadImage"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  accept='image/*'
                  :max-size="6144"
                  :action="uploadUrl"
                  name="photo[]"
            style="position:relative; margin:0px auto; display:table; align:center; line-height:unset;">-->
            <Row type="flex">
              <Col span="24" style="text-align: center">
                <img
                  alt=" "
                  id="upload-onboard-avatar"
                  :src="file"
                  style="margin:0 auto;height:100px;overflow:hidden;border-radius:100%;border:5px solid #ddd;vertical-align:middle;text-align:center;"
                  width="100"
                  height="100"
                />
                <p>
                  <a class @click="getRandomAvatar()">Pick an avatar for me randomly</a>
                </p>
              </Col>
              <!-- <Col span="17">
                      <Input style="margin: 0 10px" v-model="form.display_name" placeholder="Display Name"/>
                      <span style="margin: 0 10px; font-size: .9em; font-style: italic">* Used on comments and post</span>
                      <Row>
                        <Col span="12">
                          <Input style="margin: 0 10px; padding-right: 10px" v-model="form.first_name" placeholder="First Name"/>
                        </Col>
                        <Col span="12">
                          <Input style="margin: 0 10px" v-model="form.last_name" placeholder="Last Name"/>
                        </Col>
                      </Row>
                      <p style="text-align: right" v-show="form.display_name" @click="showPreviewModal = true"><a>Preview</a></p>
              </Col>-->
            </Row>

            <h2 align="center">Pick an Avatar</h2>
            <!-- </Upload> -->
            <!-- <p align="center" style="margin:10px auto 0;">
                <Button icon="loop" @click="getRandomAvatar()">Random</Button>&nbsp;
            <!-- <Button icon="camera" @click="uploadImage()" >Use Photo</Button>-->
            <!-- </p> -->

            <div class="avatar-card" style>
              <div class="avatars">
                <img
                  v-for="(avatar, i) in avatarList"
                  :key="i"
                  track-by="id"
                  :src="avatar"
                  @click="setAvatar(avatar)"
                />
              </div>
            </div>
          </FormItem>
        </div>

        <div slot="pageZipcode">
          <FormItem label="Let's find resources in your area. Please enter your zipcode:">
            <div style="display: flex">
              <Input
                type="number"
                class="text-zipcode"
                size="large"
                @on-enter="nextClicked(-1)"
                v-model="form.zipcode"
                style="margin: 20px 70px"
                placeholder="Zipcode"
              />
            </div>
          </FormItem>
        </div>

        <div slot="pageStatus" v-if="!skipUserStories">
          <FormItem label="What describes you best ?">
            <RadioGroup v-model="selectedStatus">
              <Radio
                v-for="(story, i) in sortedStories"
                :key="i"
                size="large"
                class="title-question-ui subs"
                style="margin-bottom:10px"
                :label="i"
              >{{ story.title }}</Radio>
              <Radio
                v-if="stories.length > 0"
                class="title-question-ui subs"
                size="large"
                style="margin-bottom:10px"
                :label="-1"
              >Other</Radio>
            </RadioGroup>
          </FormItem>
        </div>

        <div slot="pageInterest" v-if="!skipInterest">
          <FormItem label="What's your interest?">
            <div style="height:50vh;overflow:hidden;overflow-y:auto">
              <CheckboxGroup v-model="selectedPlan" @on-change="onChangeInterest">
                <div v-for="(n, i) in groupInterest" :key="i">
                  <Checkbox class="check-interest" size="large" :label="n.id">{{n.title}}</Checkbox>
                </div>
              </CheckboxGroup>
            </div>
          </FormItem>
        </div>

        <div slot="pageNotification">
          <FormItem label>
            <PublicProfileSW
              @onChangePublicValue="onTogglePublic"
              :public="form.is_public"
              style="margin-bottom: 30px"
            />
            <NotificationSW></NotificationSW>
          </FormItem>
        </div>
        <div slot="pageThanks">
          <FormItem label="Thank you">
            <div v-if="onboardOutro">
              <OnBoardingActivity :aid="onboardOutro" :hideLoader="true" />
            </div>
            <p
              v-else
              style="text-align:center;font-size: 3vh;line-height: 1.5;margin-bottom:16px"
            >Your journey to a more healthy mind has begun.</p>
          </FormItem>
          <!-- <div class="last-page"> -->
          <!-- <span @click="facebookShare" class="btn-fb" style="background:#3b5998;color:white;padding:0 10px">
                  <Icon type="social-facebook"/>
                  Share
          </span>-->
          <!-- <a class="btn-last-page" @click="goToHome()">
                <span>Let's do this together</span></a>
          </div>-->
        </div>
      </vue-good-wizard>
    </Form>
    <ModalHolder
      title="test"
      m-top="30"
      m-height="40vh"
      class-name="age-modal"
      :is-show="showMyndModal"
    >
      <template slot="mcontent">
        <span style="position:absolute;right:15px;top:15px" @click="showMyndModal=false">
          <img :src="closeIcon" style="height: 25px;margin-top:-5px;margin-right:-5px" />
        </span>
        <div class="about-holder">
          <p style="text-align:center;font-size: 3vh;line-height: 1.5">
            We are honored you wish to join our alliance,
            but you must wait until you are older. You are welcome to observe Sharpen School as our guest.
            God bless you child. We are proud of you.
          </p>
        </div>
      </template>
      <template class="age-modal" slot="mfooter">
        <Button type="text" @click="showMyndModal=false">Cancel</Button>
        <router-link to="/verify">
          <Button type="primary">Continue as Guest</Button>
        </router-link>
      </template>
    </ModalHolder>
    <ModalHolder title="Preview" mHeight="90px" :is-show="showPreviewModal">
      <template slot="mheader">
        <div class="flex-container direction-row center" style="justify-content:space-between;">
          <div></div>
          <b>Preview</b>
          <img
            alt=" "
            @click="showPreviewModal = false"
            style="height:25px; width:25px;"
            src="@/assets/close.png"
          />
        </div>
      </template>
      <template slot="mcontent">
        <Row>
          <Col span="4">
            <img
              :src="file"
              style="
              width: 50px !important;
              height: 50px !important;
              margin: 3px auto;
              border-radius:100%;"
              alt
            />
          </Col>
          <Col span="20" style="background: #f0f0f0; padding: 10px; border-radius: 10px">
            <span>
              <b style="color: black">{{ form.display_name }}</b>
            </span>
            <p>Sample comment</p>
          </Col>
          <div>
            <a style="margin: 2px 10px">Like</a>
            <a>Reply</a>
          </div>
        </Row>
      </template>
    </ModalHolder>
  </app-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import provinces from "@/helpers/ph-info/provinces.json";
import regions from "@/helpers/ph-info/regions.json";
import countriesJson from "@/assets/list_country.json";
import provinceJson from "@/assets/list_province.json";
import regionJson from "@/assets/list_region.json";
import NotificationSW from "@/components/PushNotificationEnabler";
import PublicProfileSW from "@/components/PublicProfileEnabler";
import ModalHolder from "@/components/ModalHolderComponent";
import OnBoardingActivity from "@/components/OnBoardingActivity";
import Utils from "@/utils.js";
import Cons from "@/constants.json";
import IframeComponent from '@/components/IFrameComponent'

function searchArrayValue(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].name === nameKey) {
      return myArray[i];
    }
  }
}

function searchCountryValue(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].country_name === nameKey) {
      return myArray[i];
    }
  }
}

export default {
  components: {
    OnBoardingActivity,
    NotificationSW,
    PublicProfileSW,
    ModalHolder,
    IframeComponent
  },
  data() {
    return {
      consentLoaded: false,
      isLastPage: false,
      skipInterest: false,
      selectedPlan: [],
      alreadFollowedPlans: [],
      groupInterest: [],
      skipUserStories: false,
      showMyndModal: false,
      showPreviewModal: false,
      regions,
      provinces,
      file: null,
      form: _.cloneDeep(this.$store.getters["user/onboarding"]),
      brandConsentForm: {email: null, user_agree: false},
      rules: {},
      isPH: true,
      advocacies: {},
      selectedSkills: [],
      skills: {},
      selectedAdvocacies: [],
      countriesKey: null,
      countryState: null,
      employment_status: "",
      shareActivity: {},
      tracks: {
        cope: [
          "Support for Foster Parents",
          "Navigating Foster Care",
          "Improving Coping Skills",
          "Veteran Resources in the Upstate",
          "Find Your Voice",
          "Volunteer Opportunities In The Community"
        ],
        thrive: [
          "Stress Management",
          "5 Minute Mindfulness",
          "Self-Care",
          "How to Teach Stress Management to Kids"
        ],
        nourish: [
          "How To Eat",
          "Mindful Eating",
          "Early Childhood Development",
          "Nourish Through The Arts",
          "Building Body Esteem",
          "Athlete Health",
          "Nourish Inner Beauty",
          "Healthy Relationships"
        ],
        heal: [
          "PTSD",
          "Childhood Trauma",
          "Eating Disorders",
          "Depression",
          "Grit",
          "Suicide Prevention",
          "Substance Use Disorders",
          "Resilience"
        ]
      },
      selectedTracks: {
        cope: [],
        thrive: [],
        nourish: [],
        heal: []
      },
      selectedStatus: null,
      consentLoading: false,
      buttonTimer: null,
      showSurveyNext: false
    };
  },
  watch: {
    $route: function(n, o) {
      if (n) {
        this.skipUserStories = false;
        if ("skip_story" in n.query && n.query.skip_story)
          this.skipUserStories = JSON.parse(n.query.skip_story);
      }
    },
    "form.region": function(n, o) {
      if (n) {
        this.form.province = "";
        this.form.city = "";
        this.form.zipcode = "";
      }
    },
    "form.country": function(n, o) {
      if (n) {
        this.form.region = "";
        this.form.province = "";
        this.form.city = "";
        this.form.zipcode = "";
        this.form.country_province = "";
        this.form.country_city = "";
        this.form.country_zipcode = "";
        this.countriesKey = searchCountryValue(n, countriesJson);
      }
    },
    "form.province": function(n, o) {
      if (n) {
        this.form.city = "";
        this.form.zipcode = "";
      }
    },
    "form.country_province": function(n, o) {
      if (n) {
        this.form.country_city = "";
        this.form.country_zipcode = "";
      }
    },
    "form.city": function(n, o) {
      if (n) {
        this.form.zipcode = "";
      }
    },
    "form.country_city": function(n, o) {
      if (n) {
        this.form.country_zipcode = "";
      }
    },
    isPH: function(n, o) {
      if (n) {
        this.form.country = "";
        this.form.region = "";
        this.form.province = "";
        this.form.city = "";
        this.form.zipcode = "";
      }
    }
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    routeBrandSlug(){
      return this.$route.params.brandSlug;
    },
    steps() {
      var steps = [];
      if(this.routeBrandSlug == 'vcom'){
        steps.push({
          label: "Consent2Message",
          slot: "pageConsent2Message"
        });

        steps.push({
          label: "Consent2",
          slot: "pageConsent2"
        });

        steps.push({
          label: "Email",
          slot: "pageEmail"
        });
      }
      if (this.onboardConsent)
        steps.push({
          label: "Consent",
          slot: "pageConsent"
        });

      steps.push({
        label: "Welcome to Sharpen",
        slot: "pageWelcome"
      });

      if (this.introContent)
        steps.push({
          label: "Intro",
          slot: "pageIntro"
        });

      if (!this.skipUserStories)
        steps.push({
          label: "What describes you best ?",
          slot: "pageStatus"
        });

      steps.push({
        label: "Avatar",
        slot: "pageAvatar"
      });

      steps.push({
        label: "Zipcode",
        slot: "pageZipcode"
      });

      if (!this.skipInterest)
        steps.push({
          label: "Interest",
          slot: "pageInterest"
        });

      steps.push({
        label: "Notification",
        slot: "pageNotification"
      });

      steps.push({
        label: "Thank you",
        slot: "pageThanks"
      });

      console.log("steps", steps);

      return steps;
    },
    getSelectedStatusId: {
      get() {
        if (this.selectedStatus === null)
          return this.getPackage.data.default_story_id;
        else if (this.selectedStatus === "-1" || this.selectedStatus === -1)
          return this.getPackage.data.default_story_id;
        else return this.sortedStories[this.selectedStatus].id;
      },
      set(v) {
        for (let index = 0; index < this.sortedStories.length; index++) {
          if (this.sortedStories[index].id === v) {
            this.selectedStatus = index;
            break;
          }
        }
      }
    },
    getEmploymentStatus: function() {
      let list = this.$store.state.onBoarding.userFields[0].fields;
      let filtered = _.filter(list, { slug: "employment_status" });
      return filtered[0].options;
    },
    getAgeBracket: function() {
      let list = this.$store.state.onBoarding.userFields[0].fields;
      let filtered = _.filter(list, { slug: "age_bracket" });
      return filtered[0].options;
    },
    selActive: {
      get() {
        return this.isPH ? "white !important" : "white !important";
      }
    },
    yes: {
      get() {
        return require("@/assets/002-like.png");
      }
    },
    no: {
      get() {
        return require("@/assets/005-hands.png");
      }
    },
    sortedadvocacies() {
      if (this.advocacies && !this.advocacies.careplan) return [];
      return this.advocacies.careplan.sort(function(a, b) {
        return ("" + a.title).localeCompare(b.title);
      });
    },
    sortedskills() {
      if (this.skills && !this.skills.careplan) return [];
      return this.skills.careplan.sort(function(a, b) {
        return ("" + a.title).localeCompare(b.title);
      });
    },
    sortedRegions() {
      return this.regions.sort(function(a, b) {
        return ("" + a.name).localeCompare(b.name);
      });
    },
    sortedProvinces() {
      return provinces.sort(function(a, b) {
        return ("" + a.name).localeCompare(b.name);
      });
    },
    sortedCountries() {
      return countriesJson.sort(function(a, b) {
        return ("" + a.country_name).localeCompare(b.country_name);
      });
    },
    sortedGlobalProvinces() {
      return regionJson.sort(function(a, b) {
        return ("" + a.region_name).localeCompare(b.region_name);
      });
    },
    getRegionKey() {
      return searchArrayValue(this.form.region, this.regions);
    },
    ...mapGetters({
      interests: "onBoarding/interests",
      supports: "onBoarding/supports",
      myUserStories: "brand/getPackageStories",
      getPackage: "packages/getPackage"
    }),
    uploadUrl() {
      return process.env.VUE_APP_API + "uploadphoto";
    },
    gender: {
      get() {
        if (!this.form.gender) {
          this.form.gender = "Rather not Specify";
        }
        return this.form.gender || "Rather not Specify";
      },
      set(val) {
        if (!this.form.avatar) this.getRandomAvatar();
        this.form.gender = val;
      }
    },
    onboardVideo() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.onboarding_video || null;
      return null;
    },
    onboardConsent() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.onboarding_acceptance || null;
      return null;
    },
    introContent() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.onboarding_intro || null;
      return null;
    },
    onboardOutro() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.onboarding_outro || null;
      return null;
    },
    avatars: {
      get() {
        return this.$store.state.user.avatars.images || [];
      }
    },
    baseUrl: {
      get() {
        return this.$store.state.user.avatars.base_url;
      }
    },
    orderedInterest: function() {
      return _.orderBy(this.groups, "value");
    },
    cities: {
      get() {
        return this.$store.state.publicModule.cities;
      }
    },
    listOfProvinces: {
      get() {
        return this.$store.state.publicModule.provinces;
      }
    },
    closeIcon: {
      get() {
        return require("@/assets/close.png");
      }
    },
    profileInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    avatarList() {
      let avatarArray = [];

      Object.keys(this.avatars).forEach(key => {
        this.avatars[key].forEach(avatar => {
          avatarArray.push(this.baseUrl + key + "/" + avatar);
        });
      });

      return avatarArray.slice().reverse();
    },
    userStoryIds() {
      return this.getPackage.data.user_story;
    },
    stories() {
      return this.$store.state.packages.stories;
    },
    sortedStories() {
      let sortedStories = [];

      this.userStoryIds.forEach(e => {
        let index = this.stories.findIndex(s => s.id === e);

        if (index >= 0) {
          sortedStories.push(this.stories[index]);
        }
      });

      return sortedStories;
    }
  },
  created() {
    this.getUserFields();
    this.getImageLibraries();
    // this.getAdvocacies()
    // this.getSkills()
  },
  mounted() {
    if(this.$refs.wizard.currentSlot == 'pageConsent2Message'){
      document.getElementsByClassName(
        "wizard__body__actions"
      )[0].style.display = "none";
    }
    //hide wizard control if onboard consent is available
    if (this.onboardConsent)
      document.getElementsByClassName(
        "wizard__body__actions"
      )[0].style.display = "none";
    this.skipUserStories =
      "skip_story" in this.$route.query && this.$route.query.skip_story
        ? JSON.parse(this.$route.query.skip_story)
        : false;
    this.getSelectedStatusId =
      this.myUserStories.length > 0
        ? this.myUserStories[0].id
        : this.getPackage.data.default_story_id;

    this.form = _.cloneDeep(this.$store.getters["user/onboarding"]);

    if (!this.form.is_public) this.form.is_public = false;

    this.file = this.form.avatar;

    // this.isPH = (this.form.country == "Philippines")
    if (
      (this.form && !this.form.avatar) ||
      this.form.avatar.indexOf("mystery-man") > -1 ||
      this.$store.getters["user/userInfo"].avatar.indexOf("mystery-man") > -1
    )
      this.getRandomAvatar();
    // if(this.form && this.form.country){this.countriesKey = searchCountryValue(this.form.country, countriesJson)}
    // if(!this.form.country_province){
    //   this.form.country_province=''
    // }
    // this.employment_status = this.form.employment_status;
    this.form.display_name = "";

    // setTimeout(()=> {
    //   this.form = _.cloneDeep(this.$store.getters['user/onboarding'])
    //   this.file = this.form.avatar;

    //   // this.isPH = (this.form.country == "Philippines")
    //   if(this.form && !this.form.avatar || this.form.avatar.indexOf('mystery-man') > -1) this.getRandomAvatar();
    //   // if(this.form && this.form.country){this.countriesKey = searchCountryValue(this.form.country, countriesJson)}
    //   // if(!this.form.country_province){
    //   //   this.form.country_province=''
    //   // }
    //   // this.employment_status = this.form.employment_status;
    //   this.form.display_name = ""
    // }, 0)
    this.$nextTick(() => {
      this.getInterest();
      this.getUserConsent();
    });
  },
  methods: {
    startTimer(){
        this.showSurveyNext = false
        this.buttonTimer = setInterval(() => {
          this.stopButtonTimer();
          this.showSurveyNext = true
        }, 20000)
    },
    stopButtonTimer() {
      if (this.buttonTimer) clearInterval(this.buttonTimer)
    },
    preventEnter(){
      event.stopPropagation();
    },
    validateEmail(){
      if(!Utils.validateEmail(this.brandConsentForm.email)){
        document.getElementsByClassName("wizard__next pull-right")[0].style.display = "none"
      }else{
        document.getElementsByClassName("wizard__next pull-right")[0].style.display = "flex"
      }
    },
    onIframeLoaded(){
    },
    accept(isAccept) {
      this.form.meta.accept_agreement = isAccept;
      this.$refs["wizard"].goNext(true);
      this.nextClicked(0)
    },
    next(isAccept) {
      this.$set(this.brandConsentForm, 'user_agree', isAccept);
      if(isAccept){
        this.$refs["wizard"].goNext(true);
      }else{
        this.$refs["wizard"].goTo(2);
      }
      this.nextClicked(this.$refs.wizard.currentStep)
    },
    surveyNext(next){
      if(next){
          this.$Message({
            closable: true,
            icon: 'help',
            message: { content: 'Have you completed the survey?' },
            buttons: [
              { 
                label: 'No', type: 'text', hideAfter:true, action: ()=> {
                }
              },
              { label: 'Yes', type: 'primary', hideAfter:true, action: ()=> {
                  this.$refs["wizard"].goNext(true);
                  this.nextClicked(this.$refs.wizard.currentStep)
                }
              }
            ]
          });
      }else{
        this.$refs["wizard"].goTo(0);
      }
    },
    onChangeInterest(n) {
      console.log(n);
    },
    addOnSubs(m) {
      if (typeof m === "undefined") return false;

      for (let x = 0; x < m.length; x++) {
        let found = this.selectedPlan.find(xx => xx === m[x].id);
        if (!found && m[x].subscribed) {
          this.selectedPlan.push(m[x].id);
          this.alreadFollowedPlans.push(m[x].id);
        }
      }
    },
    getInterest() {
      this.$store
        .dispatch("user/getResourceByTypeOnboarding")
        .then(res => {
          console.log(">>>>>>>>", res);
          this.groupInterest = res;
          this.skipInterest = this.groupInterest.length == 0;
          this.addOnSubs(res.careplan);
          console.log(res);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getUserConsent(){
      this.consentLoading = true
      this.getBrandConsent({user_id: this.profileInfo.id, brand_id: this.brandInfo.id}).then(res =>{
        this.brandConsentForm = _.cloneDeep(this.$store.state.user.consent)
        this.consentLoading = false
      },
      err=>{
        console.log(err);
        this.consentLoading = false
      })
    },
    saveUserConsent(){
      if(!this.brandConsentForm.brand_id){
        this.brandConsentForm.brand_id = this.brandInfo.id;
      }
      this.saveBrandConsent(this.brandConsentForm).then(res =>{
        console.log(res);
      },
      err=>{
        console.log(err);
      })
    },
    onTogglePublic() {
      this.form.is_public = !this.form.is_public;
      console.log(this.form);
    },
    addToSubscription(id) {
      this.selectedAdvocacies.push(id);
    },
    getSkills() {
      this.$store.dispatch("user/getAllSkills").then(res => {
        this.skills = res;
        for (let x = 0; x < this.skills.careplan.length; x++) {
          if (this.skills.careplan[x].subscribed) {
            this.selectedSkills.push(this.skills.careplan[x].id);
          }
        }
      });
    },
    getAdvocacies() {
      this.$store.dispatch("user/getAllAdvocacies").then(res => {
        this.advocacies = res;
        for (let x = 0; x < this.advocacies.careplan.length; x++) {
          if (this.advocacies.careplan[x].subscribed) {
            this.selectedAdvocacies.push(this.advocacies.careplan[x].id);
          }
        }
      });
    },
    uploadImage() {
      let el = document.getElementById("upload-onboard-avatar");
      el.click();
    },
    getRandomAvatar() {
      this.setAvatar(
        this.avatarList[
          Math.floor(Math.random() * Math.floor(this.avatarList.length))
        ]
      );
    },
    setAvatar(url) {
      this.file = url;
    },
    nextClicked(currentPage) {
      this.stopButtonTimer();
      var page = this.steps[currentPage].slot;
      this.$nextTick(()=>{
        if (this.$refs.wizard.currentSlot == "pageConsent" || this.$refs.wizard.currentSlot == "pageConsent2Message") {        
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "none"
        }else if(this.$refs.wizard.currentSlot == "pageEmail"){
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "flex";
          if(!Utils.validateEmail(this.brandConsentForm.email)){
            document.getElementsByClassName("wizard__next pull-right")[0].style.display = "none"
          }else{
            document.getElementsByClassName("wizard__next pull-right")[0].style.display = "flex"
          }
        }else if(this.$refs.wizard.currentSlot == "pageConsent2"){
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "none"
          this.startTimer();
        } else {
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "flex"
          document.getElementsByClassName("wizard__next pull-right")[0].style.display = "flex"
        }
      });

      if (page === "pageNotification") {
        this.isLastPage = true;
      }

      if (page == "pageStatus") {
        if (!this.getSelectedStatusId)
          return this.showMessageDialog("Required", "Please select a status");
        else return true;
      } else if (page == "pageThanks") this.submit();
      else return true;
    },
    backClicked(currentPage) {
      this.stopButtonTimer();
      var page = this.steps[currentPage].slot;

      if(page == 'pageEmail' && !this.brandConsentForm.user_agree){
        document.getElementsByClassName("wizard__body__actions")[0].style.display = "none"
        this.$refs["wizard"].goTo(0);
        return true
      }

      this.$nextTick(()=>{     
        if (this.$refs.wizard.currentSlot == "pageConsent" || this.$refs.wizard.currentSlot == "pageConsent2Message") {        
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "none"
        }else if(this.$refs.wizard.currentSlot == "pageEmail"){
          if(!Utils.validateEmail(this.brandConsentForm.email)){
            document.getElementsByClassName("wizard__next pull-right")[0].style.display = "none"
          }else{
            document.getElementsByClassName("wizard__next pull-right")[0].style.display = "flex"
          }
        }else if(this.$refs.wizard.currentSlot == "pageConsent2"){
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "none"
          this.startTimer();
        } else {
          document.getElementsByClassName("wizard__body__actions")[0].style.display = "flex"
          document.getElementsByClassName("wizard__next pull-right")[0].style.display = "flex"
        }
      });

      if (page === "pageThanks") {
        this.isLastPage = false;
      }

      return true;
    },
    ...mapActions({
      getUserFields: "user/getUserFields",
      getImageLibraries: "user/getImageLibraries",
      getBrandConsent: "user/getBrandConsent",
      saveBrandConsent: "user/saveBrandConsent"
    }),
    async submit() {
      try {
        await this.saveUserConsent();
        let res = await this.$store.dispatch("user/saveOnboardingData", {
          data: this.form,
          newAvatar: this.file
        });

        if (!this.skipUserStories) {
          if (
            this.myUserStories &&
            this.myUserStories.length > 0 &&
            this.myUserStories[0].id !== this.getSelectedStatusId
          ) {
            await this.$store.dispatch(
              "user/unfollowGroup",
              this.myUserStories[0].id
            );
          }

          await this.$store.dispatch("user/followGroups", {
            ids: this.getSelectedStatusId
          });
        }

        if (this.selectedPlan && this.selectedPlan.length > 0) {
          if (this.alreadFollowedPlans && this.alreadFollowedPlans.length > 0) {
            for (let x = 0; x < this.alreadFollowedPlans.length; x++) {
              let found = this.selectedPlan.find(
                m => m === this.alreadFollowedPlans[x]
              );
              if (!found)
                this.$store.dispatch(
                  "user/unfollowGroup",
                  this.alreadFollowedPlans[x]
                );
            }
          }

          await this.$store.dispatch("user/followGroups", {
            ids: this.selectedPlan.join(",")
          });
        }

        await this.$store.dispatch("user/getUserInfo");

        this.$store.dispatch(
          "points/setUserActionPoints",
          {
            action: "complete_profile"
          },
          { root: 1 }
        );

        this.$router.replace(`/${this.$route.params.brandSlug}/home`);
      } catch (e) {
        console.log("Error saving onboarding: ", e);
      }
    },
    // submit() {
    //     console.log(">>>>>>>>>>>>>>>>", this.myUserStories)
    //   this.$store.dispatch('user/saveOnboardingData',
    //     {data: this.form, newAvatar: this.file})
    //     .then(res => {
    //       console.log(">>>>>>>>>>>>>>>>", this.myUserStories)
    //       if (!_.isEmpty(this.myUserStories)){
    //         if (this.myUserStories[0].id !== this.getSelectedStatusId){
    //           this.$store.dispatch('user/unfollowGroup', this.myUserStories[0].id)
    //           this.$store.dispatch('user/followGroups', {ids: this.getSelectedStatusId})
    //         }
    //       }
    //       else
    //         this.$store.dispatch('user/followGroups', {ids: this.getSelectedStatusId})
    //       this.$store.dispatch('user/getUserInfo')
    //       this.$router.replace('/home')
    //     })
    //   return true
    // },
    handleSuccess(res, file) {
      this.setAvatar(null, file.response.uploaded[0]);
    },
    changePHStatus(status) {
      this.isPH = status;
    },
    enableNotif() {
      let btn = document.querySelector("#PUSHNOTIF");
      btn.click();
    },
    setRegionCode(value) {
      for (let i = 0; i < regionJson.length; i++) {
        if (regionJson[i].region_name == value) {
          this.countryState = regionJson[i].region_code;
          break;
        }
      }

      // for(let i=0; i<this.listOfProvinces.provinces.length; i++){
      //   if(this.listOfProvinces.provinces[i].province_name == value){
      //     this.countryState = this.listOfProvinces.provinces[i].province_code
      //     break;
      //   }
      // }
      // this.$store.commit('publicModule/emptyCities');
      // this.$store.commit('publicModule/emptyProvinces');
      // console.log(this.form)
    },
    handleCitySearch: _.debounce(function(value) {
      if (this.currentPage !== 3) return false;
      // console.log(this.value)
      this.$store.commit("publicModule/emptyCities");
      if (value) {
        this.$store.dispatch("publicModule/cities", {
          country_code: this.countriesKey.country_code,
          region_code: this.countryState,
          value: value
        });
      } else {
        this.$store.commit("publicModule/emptyCities");
      }
    }, 500),
    handleProvinceSearch: _.debounce(function(value) {
      if (value) {
        this.$store
          .dispatch("publicModule/provinces", {
            country_code: this.countriesKey.country_code,
            value: value
          })
          .then(res => {
            // this.setRegionCode()
          });
      } else {
        console.log("empty");
        this.$store.commit("publicModule/emptyProvinces");
      }
    }, 500),
    setValue(v) {
      //quick fix for radio button iview bug
      if (this.$refs.wizard.currentSlot == "page7") {
        this.form.employment_status = v;
        this.employment_status = v;
      } else if (this.$refs.wizard.currentSlot == "page6") {
        this.form.age_bracket = v;
      }
      this.form.employment_status = this.employment_status;
    },
    goToHome() {
      this.$router.replace(`/${this.$route.params.brandSlug}/home`);
    },
    processShareActivity() {
      this.$store.commit("base/setLoadingPage", true, { root: 1 });

      return new Promise(
        (resolve, reject) => {
          this.fetchShareActivity().then(res => {
            if (res.length > 0) {
              this.shareActivity = res[0];
              resolve(res);
            } else this.saveShareActivity(resolve);
          });
        },
        error => {
          reject(error);
        }
      );
    },
    saveShareActivity(resolve) {
      var payload = Cons[0].ACTIVITY;

      payload.recurrence = [Utils.setRrulePostDate(new Date())];
      payload.data_type = "content";
      payload.timing = ["now"];
      payload.show_dashboard = false;
      payload.is_published = 1;
      payload.title =
        this.profileInfo.display_name + " has joined Sharpen Warrior";
      payload.type = "share_activity";

      this.$store
        .dispatch("feed/postCareplanUpdate", {
          id: this.profileInfo.careplan_id,
          data: payload
        })
        .then(res => {
          resolve(res);
          this.shareActivity = res;
        });
    },
    fetchShareActivity() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch("user/getUserItemByType", "share_activity").then(
          res => {
            resolve(res.careplan_item);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    saveShareActivity(resolve){
        var payload =  Cons[0].ACTIVITY

        payload.recurrence = [Utils.setRrulePostDate(new Date())];
        payload.data_type = "content"
        payload.timing = ["now"]
        payload.show_dashboard = false
        payload.is_published = 1
        payload.title = this.profileInfo.display_name + " has joined Sharpen School"
        payload.type = "share_activity"

        this.$store.dispatch("feed/postCareplanUpdate", {
            id: this.profileInfo.careplan_id,
            data: payload
          })
          .then(res => {
            resolve(res)
            this.shareActivity = res
          })
      },
      fetchShareActivity(){
          return new Promise((resolve, reject) => {
             this.$store.dispatch("user/getUserItemByType", "share_activity")
              .then(res => {
                resolve(res.careplan_item)
              },
              error => {
                reject(error)
              })
          })
      },
      getActivityShareLink(act){
          return (act.data && act.data.url) ? act.data.url : ('https://preview.sharpenminds.com/preview/?activity_id=' + act.id)
      },
      facebookShare(){
        var url = this.getActivityShareLink(this.shareActivity);
        if (this.profileInfo && this.profileInfo.user_type !== 'guest' ) {
          FB.ui({
            method: 'share',
            href: url,
          }, function(response) {
            if (response)
              this.goToHome()
          }.bind(this));
        } else {
          this.$store.commit('hitCheckpoint');
        }
      },
      showMessageDialog(title, content){
        this.$Message({
            closable: true,
            title: { content: title},
            icon: 'alert',
            message: { content: content},
            buttons: [
              { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> false }
            ]
          })
      }
    }

};
</script>
